import { Card } from '@/components/ui/card';
import { Trophy, Target, Flame, Clock } from 'lucide-react';
import { TrainingStats } from '@/hooks/useTrainingStats';

interface TrainingStatsOverviewProps {
  stats: TrainingStats;
}

export function TrainingStatsOverview({ stats }: TrainingStatsOverviewProps) {
  const formatTime = (hours: number) => {
    if (hours < 1) {
      return `${Math.round(hours * 60)}m`;
    }
    const h = Math.floor(hours);
    const m = Math.round((hours - h) * 60);
    return m > 0 ? `${h}h ${m}m` : `${h}h`;
  };

  const cards = [
    {
      icon: Trophy,
      label: 'Positions Mastered',
      value: stats.totalMastered,
      subtext: `of ${stats.totalPositions} total`,
      color: 'text-teen-gold'
    },
    {
      icon: Target,
      label: 'Success Rate',
      value: `${stats.overallSuccessRate}%`,
      subtext: `${stats.totalAttempts} attempts`,
      color: 'text-teen-green'
    },
    {
      icon: Flame,
      label: 'Current Streak',
      value: stats.currentStreak,
      subtext: `Best: ${stats.longestStreak} days`,
      color: stats.currentStreak >= 7 ? 'text-teen-orange' : 'text-muted-foreground'
    },
    {
      icon: Clock,
      label: 'Time Spent',
      value: formatTime(stats.totalTimeSpentHours),
      subtext: 'training time',
      color: 'text-teen-blue'
    }
  ];

  return (
    <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-4">
      {cards.map((card, idx) => {
        const Icon = card.icon;
        return (
          <Card key={idx} className="p-6">
            <div className="flex items-center justify-between mb-2">
              <Icon className={`h-5 w-5 ${card.color}`} />
            </div>
            <div className="space-y-1">
              <p className="text-sm text-muted-foreground">{card.label}</p>
              <p className="text-3xl font-bold">{card.value}</p>
              <p className="text-xs text-muted-foreground">{card.subtext}</p>
            </div>
          </Card>
        );
      })}
    </div>
  );
}
